/* eslint-disable import/no-absolute-path */ /* eslint-disable consistent-return */ /* eslint-disable jsx-a11y/control-has-associated-label */ /* eslint-disable jsx-a11y/label-has-associated-control */ import '@assets/styles/react-grid-layout.css';

import IconPlus from '@assets/icons/plus.svg?react';
import { Box, Button } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactGridLayout, {
 useContainerWidth,
 verticalCompactor,
} from 'react-grid-layout';
import { useAppDispatch } from '@/redux/hooks';
import { resetHeaderTitle, setHeaderTitle } from '@/redux/header/headerSlice';

import DashboardWidget from '../components/dashboard/DashboardWidget';
import DashboardWidgetModal from '../components/dashboard/DashboardWidgetModal';
import useDashboard from '../hooks/useDashboard';
import customColors from '../utils/customColors';

export default function Dashboard() {
 const { t } = useTranslation();
 const dispatch = useAppDispatch();
 const {
  widgets,
  layout,
  modalOpen,
  editingWidget,
  handleLayoutChange,
  handleUpsertWidget,
  handleDelete,
  handleEdit,
  handleOpenCreateModal,
  handleModalClose,
 } = useDashboard();

 const { width, containerRef, mounted } = useContainerWidth();

 useEffect(() => {
  dispatch(setHeaderTitle(t('entities.dashboard')));
  return () => {
   dispatch(resetHeaderTitle());
  };
 }, [dispatch, t]);

 return (
  <Box sx={{ margin: '0 auto' }}>
   <Box
    sx={{
     display: 'flex',
     justifyContent: 'space-between',
     alignItems: 'center',
     marginBottom: '24px',
    }}
   >
    <Button
     variant="text"
     onClick={handleOpenCreateModal}
     sx={{ color: (theme) => theme.palette.text.primary, gap: 1 }}
    >
     {t('global.add')} <IconPlus style={{ color: customColors.darkGray }} />
    </Button>
   </Box>
   <Box ref={containerRef}>
    {mounted && (
     <ReactGridLayout
      className="layout"
      width={width}
      layout={layout}
      gridConfig={{
       cols: 6,
       rowHeight: 150,
       margin: [16, 16],
       containerPadding: [0, 0],
      }}
      dragConfig={{
       enabled: true,
       handle: '.dashboard-widget-header',
      }}
      resizeConfig={{
       enabled: true,
       handles: ['se', 'sw', 'ne', 'nw', 's', 'n', 'e', 'w'],
      }}
      onLayoutChange={handleLayoutChange}
      compactor={verticalCompactor}
     >
      {widgets.map((widget) => (
       <Box key={widget.id || '-1'}>
        <DashboardWidget widget={widget} onEdit={handleEdit} />
       </Box>
      ))}
     </ReactGridLayout>
    )}
   </Box>
   {widgets.length === 0 && (
    <Box sx={{ textAlign: 'center', padding: 0 }}>
     <Box
      //   component="p"
      sx={{
       fontSize: '20px',
       color: (theme) => theme.palette.text.secondary,
       p: 0,
      }}
     >
      {t('dashboard.noWidgetsYet')}
     </Box>
    </Box>
   )}
   <DashboardWidgetModal
    open={modalOpen}
    onClose={handleModalClose}
    onSubmit={handleUpsertWidget}
    onDelete={handleDelete}
    initialWidget={editingWidget}
   />
  </Box>
 );
}
